import { UseClaimReportWeather } from './claim-report-weather.hook'

export const ClaimReportWeather = () => {
  const {} = UseClaimReportWeather()

  return <></>
}
